import Service from "./Service";
import { TrainOrderEntity } from "../model/Train";
import { orderService } from "./orderService";
import { PageList } from "@/model/system";
class trainService extends orderService {
  // CheckRepeatOrder(data: any) {
  //   return this.post<any>("/TrainOrder/CheckRepeatOrder", data, {
  //     failTips: false,
  //   });
  // }
  // CreateOrder(data: TrainOrderEntity) {
  //   return this.post<TrainOrderEntity>(`/TrainOrder/CreateOrder`, data);
  // }
  ConsumerVerification(data: any) {
    return this.post<any>(`/TrainOrder/ConsumerVerification`, data);
  }
  // OrderDetails(UniqueID: string) {
  //   return this.get<any>(`/TrainOrder/OrderDetails?UniqueID=${UniqueID}`);
  // }
  // RefundJudge(UniqueID: string) {
  //   return this.get<any>(`/TrainOrder/RefundJudge?UniqueID=${UniqueID}`);
  // }
  // CreateAmend(amend: any) {
  //   return this.post<any>(`/TrainOrder/CreateAmend`, amend);
  // }
  OrderChange(data: any) {
    return this.post<any>("/TrainOrder/TrainOrderChange", data);
  }
  // OrderCancel(id: string) {
  //   return this.get<any>(`/TrainOrder/OrderCancel?UniqueID=${id}`);
  // }
  // OrderSubmit(UniqueID: string) {
  //   return this.get<any>(`/TrainOrder/OrderSubmit/${UniqueID}`);
  // }
  // UpdateOrderStatus(id: string) {
  //   return this.get<any>(`/TrainOrder/UpdateOrderStatus?UniqueID=${id}`);
  // }
  // OrderRefund(data: any) {
  //   return this.post<any>("/TrainOrder/OrderRefund", data);
  // }
  // SearchOrders(id: string) {
  //   return this.get<any>(`/TrainOrder/SearchOrders?UniqueID=${id}`);
  // }
  // OrderRefundCancel(id: string) {
  //   return this.get<any>(`/TrainOrder/OrderRefundCancel?UniqueID=${id}`);
  // }
  GetSimpleOrder(id: string) {
    return this.get<TrainOrderEntity>(`/TrainOrder/GetSimpleOrder?UniqueID=${id}`);
  }
  validOuterUserAct() {
    return this.get<TrainOrderEntity>(`/TrainAccount/ValidAccount`);
  }
  loginOuterUserAct(data: any) {
    return this.post<any>(`/TrainAccount/AccountLogin`, data);
  }
  retrieveSendCaptcha(data: any) {
    return this.post<any>(`/TrainAccount/ResetValid`, data);
  }
  retrieveFillCaptcha(data: any) {
    return this.post<any>(`/TrainAccount/ResetPassword`, data);
  }

  accountList(data: any) {
    return this.post<PageList<any>>("/TrainAccount/list", data);
  }

  deleteAccount(id: string) {
    return this.get("/TrainAccount/delete?id=" + id);
  }

  rebooking(id: string) {
    return this.get(`/trainorder/TrainBooking?UniqueId=${id}`);
  }
  checkAmend(id: string) {
    return this.get(`/trainorder/CheckAmend?UniqueId=${id}`);
  }
  validAccountById(data: any) {
    return this.post("/trainorder/ValidAccountById", data);
  }
  GetValidUrl(accountId: string) {
    return this.get<any>(`/TrainAccount/GetValidUrl?accountId=${accountId}`);
  }
  FaceValid(accountId: string) {
    return this.get<any>(`/TrainAccount/FaceValid?accountId=${accountId}`);
  }
  CheckPaymentAvailable(contactName: string, contactPhone: string) {
    return this.get<any>(`/trainorder/CheckPaymentAvailable?contactName=${contactName}&contactPhone=${contactPhone}`);
  }
  SaveEmployee(contactName: string, contactPhone: string) {
    return this.get<any>(`/trainorder/SaveEmployee?contactName=${contactName}&contactPhone=${contactPhone}`);
  }
  GetDeductSignUrl() {
    return this.get<any>(`/trainorder/GetDeductSignUrl`);
  }
  FaceLogin(data: any) {
    return this.post<any>("/TrainAccount/FaceLogin", data);
  }
}
export default new trainService("train", "TrainOrder");
